import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "9 10 4 15 9 20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 4v7a4 4 0 0 1-4 4H4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CornerDownLeft";
const CornerDownLeft = memo(themed(Icon));
export {
  CornerDownLeft
};
//# sourceMappingURL=corner-down-left.js.map
